import axios from './_nestAxios'

export const obtenerxIdAsEdicion = _id => axios.get(`/socios-seguimiento/${_id}`)

export const obtenerDetallexIdDetalleAsEdicion = (_idSeguimiento, _id) => axios.get(`/socios-seguimiento/${_idSeguimiento}/detalles/${_id}`)

export const obtenerTodoDetallesxId = _idSeguimiento => axios.get(`/socios-seguimiento/${_idSeguimiento}/detalles`)

export const obtenerxIdSocioAsSelect = idSocio =>
  axios.get('/socios-seguimiento', {
    params: {
      tipoConsulta: 'select',
      idSocio
    }
  })

export const nuevoDetalle = (_idSeguimiento, data) => axios.post(`/socios-seguimiento/${_idSeguimiento}/detalles`, data)

export const actualizarDetallexId = (_idSeguimiento, _id, data) => axios.put(`/socios-seguimiento/${_idSeguimiento}/detalles/${_id}`, data)

export const nuevo = data => axios.post('/socios-seguimiento', data)

export const actualizarxId = (_id, data) => axios.put(`/socios-seguimiento/${_id}`, data)

export const eliminarDetallexIdDetalle = (_idSeguimiento, _id) => axios.delete(`/socios-seguimiento/${_idSeguimiento}/detalles/${_id}`)
